import { steps } from '@/mocks/categories';

export default function HowItWorks() {
  return (
    <section id="guide" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4">
            Instrukcja
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Jak działa Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Prosty proces w pięciu krokach, który pozwoli Ci szybko znaleźć i zamówić wymarzone produkty.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2"></div>

          <div className="flex flex-col gap-6">
            {steps.map((s, i) => {
              const isEven = i % 2 === 0;
              return (
                <div
                  key={s.step}
                  className={`flex flex-col lg:flex-row items-center gap-4 lg:gap-8 ${
                    isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${isEven ? 'lg:text-right' : 'lg:text-left'} w-full`}>
                    <div className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70">
                      <span className="inline-block w-8 h-8 bg-primary-500 text-background-50 rounded-full text-sm font-bold flex items-center justify-center mb-3">
                        {s.step}
                      </span>
                      <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-1">
                        {s.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {s.description}
                      </p>
                    </div>
                  </div>
                  <div className="hidden lg:flex w-10 h-10 bg-primary-500 rounded-full items-center justify-center flex-shrink-0 z-10">
                    <i className="ri-check-line text-background-50 text-sm"></i>
                  </div>
                  <div className="flex-1 hidden lg:block"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}